import React from 'react';
interface ProgressBarProps {
  value: number;
  max: number;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  animated?: boolean;
}
export function ProgressBar({
  value,
  max,
  color = 'gradient',
  size = 'md',
  animated = false
}: ProgressBarProps) {
  const percentage = value / max * 100;
  // Map color names to values
  const colorMap = {
    gradient: 'bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500',
    white: 'bg-white',
    purple: 'bg-purple-500',
    pink: 'bg-pink-500',
    blue: 'bg-blue-500'
  };
  // Use the mapped color or the color directly if it's not in the map
  const barColor = colorMap[color] || color;
  // Map size to height
  const sizeMap = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };
  const heightClass = sizeMap[size] || sizeMap.md;
  return <div className="w-full bg-[#121212] rounded-full overflow-hidden" data-id="element-72">
      <div className={`${heightClass} rounded-full ${animated ? 'animate-pulse' : ''} ${barColor}`} style={{
      width: `${percentage}%`,
      transition: 'width 0.5s ease-in-out'
    }} data-id="element-73"></div>
    </div>;
}